import React, { useEffect, useState } from 'react'
import { Button, Form, OverlayTrigger, Tooltip, Modal} from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import BootstrapTable from 'react-bootstrap-table-next'
import ToolkitProvider from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min'
import { useFormik } from 'formik'
import validationSchemas from '../../common/validation-Schemas-Implicado'
import { Auth ,LoadingComponent} from 'recupero-comunes'
import {configuracionFormActionImplicado} from '../../store/actions/caso-general-action'
import 'recupero-comunes/dist/index.css'
import {obtenerComboCompanias, obtenerComboSeguro, obtenerComboComunas, obtenerComboVehiculos, obtenerDatosPantalla, obtenerComboMarcas, obtenerComboPais} from '../../store/actions/implicado-action'
import ModalPrincipal from './modal'

const ImplicadoTercerosDetalles = () => {
  const [lista, setLista] = useState([])
  const [show, setShow] = useState(false)
  const [ID, setID] = useState('')
  const [loading, setLoading]=useState(false)
  const [rutConductorFinal, setRutConductorFinal] = useState('')
  const [rutPropietarioFinal, setRutPropietarioFinal] = useState('')
  const [paisImplicadoFinal, setPaisImplicadoFinal] = useState('')
  const [showToast, setShowToast] = useState(false);

  const handleCloseToast = () => setShowToast(false)
  const handleShowToast = () => setShowToast(true)
  const { rutUsuario, rutOrganizacion } = Auth.currentUser()
  // El hook useSelector (redux) permite acceder al state en nuestro store.
  const data_datos_generales = useSelector((state) => state.casoGeneralReducer)
  const data_implicado = useSelector((state) => state.implicadoReducer)
  const { grillaImplicado, comboPais,datosPantalla, datosNoFormatos,rutConductor,rutPropietario } = data_implicado
  const {
    cfg_form,
    selectDocumentacion,
    documentacion,
    llaves,
    cfg_form_implicado
  } = data_datos_generales
  const dispatch = useDispatch()
  let pais='Chile'
  const handleClose = () => setShow(false)
  const handleShow = (row) => {
    setID(row.IdImplicado)
    setLoading(true)
    let query = Buffer.from(
        JSON.stringify({ rutcia: llaves['idOrgCaso'], idform: 7 })
      ).toString('base64')
      dispatch(configuracionFormActionImplicado(query))
    .then(()=>{

      let query = Buffer.from(JSON.stringify({ concepto: 212 })).toString(
        'base64'
      )
      dispatch(obtenerComboSeguro(query))
    })
    .then(()=>{
      let query = Buffer.from(
        JSON.stringify({
          idImplicado: row.IdImplicado,
          idCaso: llaves && llaves['idCaso']
        })
      ).toString('base64')
      dispatch(obtenerDatosPantalla(query))
    })
    .then(()=>{
      let query = Buffer.from(JSON.stringify({ concepto: 16 })).toString('base64')
      dispatch(obtenerComboVehiculos(query))
    })
    .then(()=>{
      let query = Buffer.from(JSON.stringify({ concepto: 18 })).toString('base64')
      dispatch(obtenerComboPais(query))
    })
    .then(()=>{
      if (llaves) {
        let query = Buffer.from(
          JSON.stringify({ rutCia: llaves['idOrgCaso'], parametro: 45 })
        ).toString('base64')
        dispatch(obtenerComboComunas(query))
      }
    })
    .then(()=>{
      if (llaves) {
        let query = Buffer.from(
          JSON.stringify({ idOrgCaso: llaves['idOrgCaso'] })
        ).toString('base64')
        dispatch(obtenerComboMarcas(query))
      }
    })
    .then(()=>{
      let query = Buffer.from(JSON.stringify({})).toString('base64')
      dispatch(obtenerComboCompanias(query))
    })
    .then(()=>setLoading(false))
    setShow(true)
  }




  useEffect(() => {
    setLista(grillaImplicado && grillaImplicado.grillaImplicado)
  }, [grillaImplicado])

  

  const obtenerColumnas = () => {
    return [
      {
        dataField: 'IdImplicado',
        text:cfg_form ? cfg_form.cfg_form[
          'gestcasosrecup-grillaimpl-id'
        ]:'',
        sort: true,
        headerAlign: 'center',
        align: 'center',
        headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
          <div>
            {column.text}
            <br />
            {sortElement}
          </div>
        ),
        headerStyle: {
          backgroundColor: '#728bb0',
          color: 'white',
          verticalAlign: 'middle'
        }
      },
      {
        dataField: 'NombreImplicado',
        text:cfg_form ? cfg_form.cfg_form[
          'gestcasosrecup-grillaimpl-nomrazsoc'
        ]:'',
        sort: true,
        headerAlign: 'center',
        align: 'center',
        headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
          <div>
            {column.text}
            <br />
            {sortElement}
          </div>
        ),
        headerStyle: (colum, colIndex) => {
          return {
            width: '15%',
            textAlign: 'center',
            verticalAlign: 'middle',
            backgroundColor: '#728bb0',
            color: 'white'
          }
        }
      },
      {
        dataField: 'TipoVehiculo',
        text:cfg_form ? cfg_form.cfg_form[
          'gestcasosrecup-grillaimpl-tipovh'
        ]:'',
        sort: true,
        headerAlign: 'center',
        align: 'center',
        headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
          <div>
            {column.text}
            <br />
            {sortElement}
          </div>
        ),
        headerStyle: { backgroundColor: '#728bb0', color: 'white' }
      },
      {
        dataField: 'PlacaPatente',
        text: cfg_form ?cfg_form.cfg_form[
          'gestcasosrecup-grillaimpl-patente'
        ]:'',
        sort: true,
        headerAlign: 'center',
        align: 'center',
        headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
          <div>
            {column.text}
            <br />
            {sortElement}
          </div>
        ),
        headerStyle: { backgroundColor: '#728bb0', color: 'white' }
      },
      {
        dataField: 'TipoGestion',
        text:cfg_form ? cfg_form.cfg_form[
          'gestcasosrecup-grillaimpl-tipogestion'
        ]:'',
        sort: true,
        headerAlign: 'center',
        align: 'center',
        headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
          <div>
            {column.text}
            <br />
            {sortElement}
          </div>
        ),
        headerStyle: { backgroundColor: '#728bb0', color: 'white' }
      },
      {
        dataField: 'EstadoCaso',
        text: cfg_form ?cfg_form.cfg_form[
          'gestcasosrecup-grillaimpl-estado'
        ]:'',
        sort: true,
        headerAlign: 'center',
        align: 'center',
        headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
          <div>
            {column.text}
            <br />
            {sortElement}
          </div>
        ),
        headerStyle: {
          backgroundColor: '#728bb0',
          color: 'white',
          verticalAlign: 'middle'
        }
      },
      {
        dataField: 'FechaEstadoFormat',
        text:cfg_form ? cfg_form.cfg_form[
          'gestcasosrecup-grillaimpl-fecestado'
        ]:'',
        sort: true,
        headerAlign: 'center',
        align: 'center',
        headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
          <div>
            {column.text}
            <br />
            {sortElement}
          </div>
        ),
        headerStyle: {
          backgroundColor: '#728bb0',
          color: 'white',
          verticalAlign: 'middle'
        }
      },
      {
        dataField: 'SeguroImplicado',
        text: cfg_form ? cfg_form.cfg_form[
          'gestcasosrecup-grillaimpl-seguro'
        ]:'',
        sort: true,
        headerAlign: 'center',
        align: 'center',
        headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
          <div>
            {column.text}
            <br />
            {sortElement}
          </div>
        ),
        headerStyle: {
          backgroundColor: '#728bb0',
          color: 'white',
          verticalAlign: 'middle'
        }
      },
      {
        dataField: 'CiaImplicado',
        text:  cfg_form ?cfg_form.cfg_form[
          'gestcasosrecup-grillaimpl-cia'
        ]:'',
        sort: true,
        headerAlign: 'center',
        align: 'center',
        headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
          <div>
            {column.text}
            <br />
            {sortElement}
          </div>
        ),
        headerStyle: {
          backgroundColor: '#728bb0',
          color: 'white',
          verticalAlign: 'middle'
        }
      },
      {
        dataField: 'opciones',
        text: '',
        isDummyField: true,
        headerStyle: (colum, colIndex) => {
          return {
            width: '40%',
            textAlign: 'center',
            verticalAlign: 'center',
            backgroundColor: '#728bb0',
            color: 'white'
          }
        },
        style: { textAlign: 'center', verticalAlign: 'middle' },
        formatter: (cell, row) => (
          <div>
            <OverlayTrigger
              overlay={<Tooltip id='tooltip-disabled'>Detalles </Tooltip>}
            >
              <Button
                type='button'
                variant='opciones me-md-2'
                size='sm'
                onClick={() => handleShow(row)}
              >
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='16'
                  height='16'
                  fill='currentColor'
                  className='bi bi-gear-fill'
                  viewBox='0 0 16 16'
                >
                  <path d='M9.405 1.05c-.413-1.4-2.397-1.4-2.81 0l-.1.34a1.464 1.464 0 0 1-2.105.872l-.31-.17c-1.283-.698-2.686.705-1.987 1.987l.169.311c.446.82.023 1.841-.872 2.105l-.34.1c-1.4.413-1.4 2.397 0 2.81l.34.1a1.464 1.464 0 0 1 .872 2.105l-.17.31c-.698 1.283.705 2.686 1.987 1.987l.311-.169a1.464 1.464 0 0 1 2.105.872l.1.34c.413 1.4 2.397 1.4 2.81 0l.1-.34a1.464 1.464 0 0 1 2.105-.872l.31.17c1.283.698 2.686-.705 1.987-1.987l-.169-.311a1.464 1.464 0 0 1 .872-2.105l.34-.1c1.4-.413 1.4-2.397 0-2.81l-.34-.1a1.464 1.464 0 0 1-.872-2.105l.17-.31c.698-1.283-.705-2.686-1.987-1.987l-.311.169a1.464 1.464 0 0 1-2.105-.872l-.1-.34zM8 10.93a2.929 2.929 0 1 1 0-5.86 2.929 2.929 0 0 1 0 5.858z' />
                </svg>
              </Button>
            </OverlayTrigger>
          </div>
        ),
        headerStyle: { backgroundColor: '#728bb0', color: 'white' }
      }
    ]
  }
  const formik = useFormik({
    initialValues: {
      idCaso: '',
      idImplicado: '',
      tipoVehiculo: '',
      seguro: '',
      idCompania: '',
      idSiniestroIM: '',
      fechaSiniestroIM: '',
      patente: '',
      marcaVehiculo: '',
      detalleDescripcion: ''
    },
    validationSchema: validationSchemas(pais, paisImplicadoFinal),
    onSubmit: (formData) => {
      const rutImplicado =
      datosNoFormatos &&
      datosNoFormatos.substring(0, datosNoFormatos.length - 1)
      const dvRutImplicado =
      datosNoFormatos &&
      datosNoFormatos.substring(
        datosNoFormatos.length - 1,
        datosNoFormatos.length)
      const rutConductor1 =
        rutConductor &&
        rutConductor.substring(0, rutConductor.length - 1)
      const dvRutConductor =
      rutConductor &&
      rutConductor.substring(
        rutConductor.length - 1,
        rutConductor.length)
      const rutPropietario1 =
        rutPropietario &&
        rutPropietario.substring(0, rutPropietario.length - 1)
      const dvRutPropietario =
      rutPropietario &&
        rutPropietario.substring(
          rutPropietario.length - 1,
          rutPropietario.length)
      const data = {
        terceroImplicado: {},
        implicado: {},
        propietario: {},
        conductorIM: {}
      }
      const dataForm = { ...formData }
      data.terceroImplicado['idUsuario'] = rutUsuario;
      data.terceroImplicado['tipoVehiculo'] = dataForm['tipoVehiculo']
      data.terceroImplicado['idCaso'] = llaves &&llaves['idCaso']
      data.terceroImplicado['idImplicado'] = ID
      data.terceroImplicado['seguro'] = dataForm['seguro']
      data.terceroImplicado['idCompania'] = dataForm['idCompania']
      data.terceroImplicado['idSiniestroIM'] = dataForm['idSiniestroIM']
      data.terceroImplicado['fechaSiniestroIM'] = dataForm['fechaSiniestroIM']
      data.terceroImplicado['patente'] = dataForm['patente']
      data.terceroImplicado['marcaVehiculo'] = dataForm['marcaVehiculo']
      data.terceroImplicado['detalleDescripcion'] =
      dataForm['detalleDescripcion']
      data.implicado['rut'] = rutImplicado && rutImplicado[rutImplicado.length-1]==="-"?rutImplicado.substring(0,rutImplicado.length-1):rutImplicado
      data.implicado['dvRut'] = dvRutImplicado && dvRutImplicado
      data.implicado['nombre'] = dataForm['nombreImplicado']
      data.implicado['direccion'] = dataForm['direccionImplicado']
      data.implicado['email'] = dataForm['emailImplicado']
      data.implicado['paisFono'] = comboPais && dataForm['paisImplicado']!==''? comboPais.comboPais?.find(c=>c.id === parseInt(dataForm['paisImplicado']))?.nombre:''
      data.implicado['paisMovil'] = comboPais && comboPais.comboPais?.find(c=>c.id === parseInt(dataForm['paisMovilImplicado']))?.nombre
      data.implicado['fono'] = dataForm['fonoImplicado']
      data.implicado['movil'] = dataForm['movilImplicado']
      data.implicado['comuna'] = dataForm['comunaImplicado']
      data.implicado['idInvolucrado'] = datosPantalla && datosPantalla.datosPantalla[0]['IdInvolucradoImp']!==undefined && datosPantalla.datosPantalla[0]['IdInvolucradoImp']!==null && datosPantalla.datosPantalla[0]['IdInvolucradoImp'] !==''?datosPantalla.datosPantalla[0]['IdInvolucradoImp']:1
      data.conductorIM['rut'] = rutConductor1 && rutConductor1[rutConductor1.length-1]==="-"?rutConductor1.substring(0,rutConductor1.length-1):rutConductor1
      data.conductorIM['dvRut'] = dvRutConductor && dvRutConductor
      data.conductorIM['nombre'] = dataForm['nombreConductor']
      data.conductorIM['direccion'] = dataForm['direccionConductor']
      data.conductorIM['email'] = dataForm['emailConductor']
      data.conductorIM['paisFono'] = comboPais && comboPais.comboPais?.find(c=>c.id === parseInt(dataForm['paisConductor']))?.nombre
      data.conductorIM['paisMovil'] = comboPais && comboPais.comboPais?.find(c=>c.id === parseInt(dataForm['paisMovilConductor']))?.nombre
      data.conductorIM['fono'] = dataForm['fonoConductor']
      data.conductorIM['movil'] = dataForm['movilConductor']
      data.conductorIM['comuna'] = dataForm['comunaConductor']
      data.conductorIM['idInvolucrado'] = datosPantalla && datosPantalla.datosPantalla[0]['IdInvolucradoCond']!==undefined && datosPantalla.datosPantalla[0]['IdInvolucradoCond']!==null && datosPantalla.datosPantalla[0]['IdInvolucradoCond'] !==''?datosPantalla.datosPantalla[0]['IdInvolucradoCond']:3
      data.propietario['rut'] = rutPropietario1 && rutPropietario1[rutPropietario1.length-1]==="-"?rutPropietario1.substring(0,rutPropietario1.length-1):rutPropietario1
      data.propietario['dvRut'] = dvRutPropietario && dvRutPropietario
      data.propietario['nombre'] = dataForm['nombrePropietario']
      data.propietario['direccion'] = dataForm['direccionPropietario']
      data.propietario['email'] = dataForm['emailPropietario']
      data.propietario['paisFono'] = comboPais && comboPais.comboPais?.find(c=>c.id === parseInt(dataForm['paisPropietario']))?.nombre
      data.propietario['fono'] = dataForm['fonoPropietario']
      data.propietario['movil'] = dataForm['movilPropietario']
      data.propietario['comuna'] = dataForm['comunaPropietario']
      data.propietario['paisMovil'] = comboPais && comboPais.comboPais?.find(c=>c.id === parseInt(dataForm['paisMovilPropietario']))?.nombre
      data.propietario['idInvolucrado'] = ID
      data.propietario['idInvolucrado'] = datosPantalla && datosPantalla.datosPantalla[0]['IdInvolucradoProp']!==undefined && datosPantalla.datosPantalla[0]['IdInvolucradoProp']!==null && datosPantalla.datosPantalla[0]['IdInvolucradoProp'] !==''?datosPantalla.datosPantalla[0]['IdInvolucradoProp']:2
      dispatch(enviarActualizacionImplicado(data))
      handleShowToast()
    }
  })
  return (
    <div>
      {/* <LoadingComponent show={loading}/> */}
      <style type='text/css'>
        {`
        .btn-opciones {
      background-color: #00aeab;
      color: #FFFFFF;



    }
    .btn-carpeta:hover{
        background-color:#01ceca;
        color: #FFFFFF;

    }
    .btn-actualizar {
      background-color: #C14B49;
      color: #FFFFFF;
      width: 140px;
      padding:6px 0px 6px 0px;

    }
    .btn-actualizar:hover{
        background-color: #d3807f;
      color: #FFFFFF;
    }

     `}
      </style>
      <Modal show={show} onHide={handleClose} size='xl'>
        <Form onSubmit={formik.handleSubmit}>
          <ModalPrincipal
            ID={ID}
            formik={formik}

            setRutConductorFinal={setRutConductorFinal}
            setRutPropietarioFinal={setRutPropietarioFinal}
            setPaisImplicadoFinal={setPaisImplicadoFinal}
            setShowToast={setShowToast}
            showToast={showToast}
          />
          <Modal.Footer>
            <Button variant='outline-info' onClick={handleClose}>
              Volver
            </Button>
            
          </Modal.Footer>
        </Form>
      </Modal>
      {cfg_form ? (
        <ToolkitProvider
          search
          bootstrap4
          keyField='IdImplicado'
          data={lista ? lista : []}
          columns={obtenerColumnas()}
          defaultSorted={[{ dataField: 'FechaEstadoFormat', order: 'asc' }]}
        >
          {(props) => (
            <div>
              <div
                className='rounded mb-0'
                style={{ backgroundColor: '#D1F2EB', color: '#4F517A' }}
              >
                <h6 className='p-2'>{`${cfg_form.cfg_form['gestcasosrecup-grillaimpl-title']} `}</h6>
              </div>

              <BootstrapTable
                {...props.baseProps}
                bordered={false}
                headerWrapperClasses='table-secondary'
               
                noDataIndication={
                  <div className='text-center'>
                    No hay registros encontrados
                  </div>
                }
              />
            </div>
          )}
        </ToolkitProvider>
        
      ) : null}
      
    </div>
  )
}

export default ImplicadoTercerosDetalles
